import {
  getPage,
  getAll,
  getDetail,
  getClientPage,
  getMyUserGroupAll,
  getMyUserGroupPage,
  changeBusinessUser,
  getMyBusinessPage,
  confirmRecept,
  cancel,
  getTeamReport,
  getReport,
  closePayOrder,
  callbackClient,
  addToRemark,
  changeSim,
  refuseService,
  confirmServiceDatetime,
  confirmFileReady,
  renewalPayPackage,
  confirmRefuseService,
} from '@/api/renewalorderserv'

export default {
  state: {
    state_RenewalOrder_GetPageResult: null,
    state_RenewalOrder_GetAllResult: null,
    state_RenewalOrder_GetDetailResult: null,
    state_RenewalOrder_GetClientPageResult: null,
    state_RenewalOrder_GetMyUserGroupAllResult: null,
    state_RenewalOrder_GetMyUserGroupPageResult: null,
    state_RenewalOrder_ChangeBusinessUserResult: null,
    state_RenewalOrder_GetMyBusinessPageResult: null,
    state_RenewalOrder_ConfirmReceptResult: null,
    state_RenewalOrder_CancelResult: null,
    state_RenewalOrder_GetTeamReportResult: null,
    state_RenewalOrder_GetReportResult: null,
    state_RenewalOrder_ClosePayOrderResult: null,
    state_RenewalOrder_CallbackClientResult: null,
    state_RenewalOrder_AddToRemarkResult: null,
    state_RenewalOrder_ChangeSimResult: null,
    state_RenewalOrder_RefuseServiceResult: null,
    state_RenewalOrder_ConfirmServiceDatetimeResult: null,
    state_RenewalOrder_ConfirmFileReadyResult: null,
    state_RenewalOrder_RenewalPayPackageResult: null,
    state_RenewalOrder_ConfirmRefuseServiceResult: null,
  },
  mutations: {
    SET_RENEWALORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetPageResult = rst;
    },
    SET_RENEWALORDER_GETALL_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetAllResult = rst;
    },
    SET_RENEWALORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetDetailResult = rst;
    },
    SET_RENEWALORDER_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetClientPageResult = rst;
    },
    SET_RENEWALORDER_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetMyUserGroupAllResult = rst;
    },
    SET_RENEWALORDER_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetMyUserGroupPageResult = rst;
    },
    SET_RENEWALORDER_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_RenewalOrder_ChangeBusinessUserResult = rst;
    },
    SET_RENEWALORDER_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetMyBusinessPageResult = rst;
    },
    SET_RENEWALORDER_CONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_RenewalOrder_ConfirmReceptResult = rst;
    },
    SET_RENEWALORDER_CANCEL_RESULT: (state, rst) => {
      state.state_RenewalOrder_CancelResult = rst;
    },
    SET_RENEWALORDER_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetTeamReportResult = rst;
    },
    SET_RENEWALORDER_GETREPORT_RESULT: (state, rst) => {
      state.state_RenewalOrder_GetReportResult = rst;
    },
    SET_RENEWALORDER_CLOSEPAYORDER_RESULT: (state, rst) => {
      state.state_RenewalOrder_ClosePayOrderResult = rst;
    },
    SET_RENEWALORDER_CALLBACKCLIENT_RESULT: (state, rst) => {
      state.state_RenewalOrder_CallbackClientResult = rst;
    },
    SET_RENEWALORDER_ADDTOREMARK_RESULT: (state, rst) => {
      state.state_RenewalOrder_AddToRemarkResult = rst;
    },
    SET_RENEWALORDER_CHANGESIM_RESULT: (state, rst) => {
      state.state_RenewalOrder_ChangeSimResult = rst;
    },
    SET_RENEWALORDER_REFUSESERVICE_RESULT: (state, rst) => {
      state.state_RenewalOrder_RefuseServiceResult = rst;
    },
    SET_RENEWALORDER_CONFIRMSERVICEDATETIME_RESULT: (state, rst) => {
      state.state_RenewalOrder_ConfirmServiceDatetimeResult = rst;
    },
    SET_RENEWALORDER_CONFIRMFILEREADY_RESULT: (state, rst) => {
      state.state_RenewalOrder_ConfirmFileReadyResult = rst;
    },
    SET_RENEWALORDER_RENEWALPAYPACKAGE_RESULT: (state, rst) => {
      state.state_RenewalOrder_RenewalPayPackageResult = rst;
    },
    SET_RENEWALORDER_CONFIRMREFUSESERVICE_RESULT: (state, rst) => {
      state.state_RenewalOrder_ConfirmRefuseServiceResult = rst;
    },
  },
  actions: {
    RenewalOrderServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetMyUserGroupAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETMYUSERGROUPALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETMYUSERGROUPALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ChangeBusinessUser({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CHANGEBUSINESSUSER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CHANGEBUSINESSUSER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetMyBusinessPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETMYBUSINESSPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETMYBUSINESSPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ConfirmRecept({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmRecept(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CONFIRMRECEPT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CONFIRMRECEPT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_Cancel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CANCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CANCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetTeamReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETTEAMREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETTEAMREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_GetReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_GETREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_GETREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ClosePayOrder({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        closePayOrder(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CLOSEPAYORDER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CLOSEPAYORDER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_CallbackClient({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        callbackClient(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CALLBACKCLIENT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CALLBACKCLIENT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_AddToRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addToRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_ADDTOREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_ADDTOREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ChangeSim({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeSim(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CHANGESIM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CHANGESIM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_RefuseService({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        refuseService(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_REFUSESERVICE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_REFUSESERVICE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ConfirmServiceDatetime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmServiceDatetime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CONFIRMSERVICEDATETIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CONFIRMSERVICEDATETIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ConfirmFileReady({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmFileReady(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CONFIRMFILEREADY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CONFIRMFILEREADY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_RenewalPayPackage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        renewalPayPackage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_RENEWALPAYPACKAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_RENEWALPAYPACKAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalOrderServ_ConfirmRefuseService({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmRefuseService(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALORDER_CONFIRMREFUSESERVICE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALORDER_CONFIRMREFUSESERVICE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_RenewalOrder_GetPageResult: state => {
      return state.state_RenewalOrder_GetPageResult;
    },
    get_RenewalOrder_GetAllResult: state => {
      return state.state_RenewalOrder_GetAllResult;
    },
    get_RenewalOrder_GetDetailResult: state => {
      return state.state_RenewalOrder_GetDetailResult;
    },
    get_RenewalOrder_GetClientPageResult: state => {
      return state.state_RenewalOrder_GetClientPageResult;
    },
    get_RenewalOrder_GetMyUserGroupAllResult: state => {
      return state.state_RenewalOrder_GetMyUserGroupAllResult;
    },
    get_RenewalOrder_GetMyUserGroupPageResult: state => {
      return state.state_RenewalOrder_GetMyUserGroupPageResult;
    },
    get_RenewalOrder_ChangeBusinessUserResult: state => {
      return state.state_RenewalOrder_ChangeBusinessUserResult;
    },
    get_RenewalOrder_GetMyBusinessPageResult: state => {
      return state.state_RenewalOrder_GetMyBusinessPageResult;
    },
    get_RenewalOrder_ConfirmReceptResult: state => {
      return state.state_RenewalOrder_ConfirmReceptResult;
    },
    get_RenewalOrder_CancelResult: state => {
      return state.state_RenewalOrder_CancelResult;
    },
    get_RenewalOrder_GetTeamReportResult: state => {
      return state.state_RenewalOrder_GetTeamReportResult;
    },
    get_RenewalOrder_GetReportResult: state => {
      return state.state_RenewalOrder_GetReportResult;
    },
    get_RenewalOrder_ClosePayOrderResult: state => {
      return state.state_RenewalOrder_ClosePayOrderResult;
    },
    get_RenewalOrder_CallbackClientResult: state => {
      return state.state_RenewalOrder_CallbackClientResult;
    },
    get_RenewalOrder_AddToRemarkResult: state => {
      return state.state_RenewalOrder_AddToRemarkResult;
    },
    get_RenewalOrder_ChangeSimResult: state => {
      return state.state_RenewalOrder_ChangeSimResult;
    },
    get_RenewalOrder_RefuseServiceResult: state => {
      return state.state_RenewalOrder_RefuseServiceResult;
    },
    get_RenewalOrder_ConfirmServiceDatetimeResult: state => {
      return state.state_RenewalOrder_ConfirmServiceDatetimeResult;
    },
    get_RenewalOrder_ConfirmFileReadyResult: state => {
      return state.state_RenewalOrder_ConfirmFileReadyResult;
    },
    get_RenewalOrder_RenewalPayPackageResult: state => {
      return state.state_RenewalOrder_RenewalPayPackageResult;
    },
    get_RenewalOrder_ConfirmRefuseServiceResult: state => {
      return state.state_RenewalOrder_ConfirmRefuseServiceResult;
    },
  }
}